module.exports = __webpack_public_path__ + "img/car_24.a04dac39.jpg";